module.exports = __webpack_public_path__ + "img/maintenance.57551654.svg";